<template lang="pug">
div
  .logo: Logo(:light='!$store.state.preference.isDarkTheme' :size='360')

  v-card.mb-2(flat)
    v-card-text
      .title.mb-3.mt-2 關於
      p 您正在使用#[b 樂台計畫]後台管理系統，若使用時遇到問題或有任何建議，請隨時來信與我們聯繫。

      v-list(two-line)
        v-list-tile(v-for='(i, index) in contact' :key='index')
          v-list-tile-avatar(v-if='i.img'): img(:src='i.img')
          v-list-tile-content
            v-list-tile-title {{ i.name }} #[small.grey--text.ml-1 {{ i.position }}]
            v-list-tile-sub-title
              v-icon(small).disable-select.mr-1 mail
              span {{ i.mail }}
            v-list-tile-sub-title(v-if='i.lineId')
              v-icon(small).mr-1 fab fa-line
              | {{ i.lineId }}

  v-card.mb-2(flat)
    v-card-text
      .title.mb-3.mt-2 後台更新記錄
      .mb-2(v-for='i in updateListPart')
        h6 {{ i.title }} ({{ convertDate(i.date) }})
        ul(v-for='_ in i.items')
          li {{ _ }}
      v-btn(depressed small @click='isUpdateShow = !isUpdateShow'): v-icon(small) fas {{ !isUpdateShow ? `fa-angle-double-down` : `fa-angle-double-up`}}
  .copyright.grey--text
    span.mr-1 Copyright © 2018-{{ new Date().getFullYear() }} #[a.grey--text(href='https://mcip.app/' target='_blank') 樂台計畫].
    span All rights reserved
</template>

<script>
import moment from 'moment'
import Loader from '@/components/Loader.vue'
import Logo from '@/components/Logo.vue'
import * as support from '@/assets/js/support'

export default {
  name: 'Support',
  metaInfo () {
    return {
      title: this.$t('關於'),
    }
  },
  data () {
    return {
      ...support,
      isUpdateShow: false,
    }
  },
  methods: {
    convertDate (_) {
      const importDateFormat = 'YYYY/MM/DD'
      return this.isUpdateShow
        ? moment(_, importDateFormat).format('YYYY/MM/DD')
        : moment(_, importDateFormat).locale('zh-tw').fromNow()
    },
  },
  computed: {
    updateListPart () {
      return !this.isUpdateShow
        ? [this.version[0]]
        : this.version
    },
  },
  components: {
    Loader,
    Logo,
  },
}
</script>

<style scoped lang="sass">
.logo
  overflow: hidden
  padding-bottom: 1rem

.disable-select
  user-select: none

.school
  margin: .5rem
  img
    border-radius: 10px
    background-color: #eee
    +wh(100px)

.copyright
  margin-top: 1.5rem
  font-size: 80%
</style>
